<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form ref="form">
      <v-row class="pb-6">
        <v-col cols="12">
          <p class="form__title primary--text mb-6">
            INSERIR MINUTA
          </p>
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormInput
            id-element="numberDraftContract"
            placeholder="Insira"
            v-model="form.numero"
            required
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Número"
            type="number"
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormInput
            id-element="dateDraftContract"
            placeholder="DD/MM/AAAA"
            v-model="form.emitida_em"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Data da Emissão"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <BaseMoney
            id-element="valueDraftContract"
            placeholder="R$ 0,00"
            v-model="form.valor"
            required
            :rules="[requiredInput]"
            label-text="Valor da Minuta"
          />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseFormInput
            id-element="startTermDraftContract"
            placeholder="DD/MM/AAAA"
            v-model="form.inicio_vigencia"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Início da Vigência"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <BaseFormInput
            id-element="endTermDraftContract"
            placeholder="DD/MM/AAAA"
            v-model="form.fim_vigencia"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Fim da Vigência"
          />
        </v-col>
        <v-col cols="12">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.comentario"
            :rules="[maxLengthTextArea]"
            label-text="Comentário"
          />
        </v-col>
        <v-col cols="12">
          <p class="primary--text mb-2 body-2 font-weight-bold">
            Anexar minuta
          </p>
        </v-col>
        <v-col cols="12">
          <DropFile
            @selected-files="addFiles"
            :multiple="false"
            class="mb-5"
            v-if="form.documents.length == 0"
          />
          <DocumentDataTable
            v-if="form.documents.length > 0"
            :documents="form.documents"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFile"
          />
          <div
            v-if="errorMessagesDocument.length > 0"
            class="v-text-field__details mt-4"
          >
            <div class="v-messages theme--light error--text" role="alert">
              <div class="v-messages__wrapper">
                <div
                  v-for="(message, index) in errorMessagesDocument"
                  :key="`error-message-${index}`"
                  class="v-messages__message"
                >
                  {{ message }}
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="12" sm="5" md="3" xl="2" class="pr-sm-5 pb-5 pb-sm-0">
            <BaseButton
              v-html="'CANCELAR'"
              color="secondary"
              outlined
              width="100%"
              @click="previousPage"
            />
          </v-col>
          <v-col cols="12" sm="5" md="3" xl="2">
            <BaseButton
              v-html="'INSERIR MINUTA'"
              class="white--text secondary"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeModal"
      title="MINUTA INSERIDA"
      text="O arquivo de Minuta foi inserido com sucesso!
            Aguarde o cliente aprovar."
    />
  </Main>
</template>
<script>
import {
  requiredInput,
  dateTermValid,
  maxLengthTextArea
} from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import ModalGenericCriticism from "../components/ModalGenericCriticism";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import {
  formatDDMMYYYYToIsoDate,
  convertStringMoneyToNumber,
  formatDateToDDMMYYYY
} from "@/utils/formats.js";
import _ from "lodash";
export default {
  data: () => ({
    requiredInput,
    dateTermValid,
    maskDate,
    errorMessagesDocument: [],
    form: {
      documents: [],
      fim_vigencia: null,
      emitida_em: null,
      valor: 0,
      inicio_vigencia: null,
      numero: null
    },
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    breadcrumb: [],
    modal: false,
    formatDDMMYYYYToIsoDate,
    convertStringMoneyToNumber,
    formatDateToDDMMYYYY,
    maxLengthTextArea
  }),
  components: {
    DocumentDataTable,
    DropFile,
    ModalGenericCriticism
  },
  mixins: [LoadingRequest, DocumentsMixin],
  created() {
    this.fetchQuotation();
  },
  computed: {
    ...mapState("quotation", ["currentQuotation"])
  },
  methods: {
    ...mapActions("quotation", [
      "requestCurrentQuotation",
      "requestNewDraftContract"
    ]),
    ...mapActions("insuranceCompany", ["requestUploadLogo"]),
    fetchQuotation() {
      this.withLoading(this.requestCurrentQuotation(this.$route.params.id));
    },
    validate() {
      if (this.form.documents.length == 0) {
        this.errorMessagesDocument = ["É preciso anexar a minuta"];
      } else {
        this.errorMessagesDocument = [];
      }
      return this.$refs.form.validate() && this.form.documents.length > 0;
    },
    async submit() {
      if (!this.validate()) return;
      const payload = await this.mountedPayload();
      this.withLoading(
        this.requestNewDraftContract(this.getPayloadDraft(payload)).then(() => {
          this.modal = true;
        })
      );
    },
    async mountedPayload() {
      let payload = _.cloneDeep(this.form);
      payload.arquivo = await this.withLoading(
        this.requestUploadLogo(
          this.getUploadFilePayload(payload.documents[0].arquivo[FILE])
        )
      );
      payload.emitida_em = this.formatDDMMYYYYToIsoDate(payload.emitida_em);
      payload.fim_vigencia = this.formatDDMMYYYYToIsoDate(payload.fim_vigencia);
      payload.inicio_vigencia = this.formatDDMMYYYYToIsoDate(
        payload.inicio_vigencia
      );
      payload.valor = this.convertStringMoneyToNumber(payload.valor);
      return payload;
    },
    getPayloadDraft(payload) {
      return {
        id: this.$route.params.id,
        payload: payload
      };
    },
    previousPage() {
      this.$router.push({
        name: "quotation element",
        params: { id: this.$route.params.id }
      });
    },
    addFiles(files) {
      const documents = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));
      this.form.documents = documents.slice(0, 1);
    },
    onRemoveFile(item) {
      this.form.documents = this.form.documents.filter(
        document => document.name !== item.name
      );
    },
    closeModal() {
      this.modal = false;
      this.previousPage();
    },
    updateForm(value) {
      this.form.valor = _.cloneDeep(value.minuta.valor);
      this.form.fim_vigencia = this.formatDateToDDMMYYYY(
        _.cloneDeep(value.fim_vigencia)
      );
      this.form.inicio_vigencia = this.formatDateToDDMMYYYY(
        _.cloneDeep(value.inicio_vigencia)
      );
    }
  },
  watch: {
    currentQuotation(value) {
      this.updateForm(value);
      this.breadcrumb = [
        {
          text: `Cotação - ${value.numero}`,
          to: "quotation element"
        }
      ];
    }
  }
};
</script>
